import React from "react";

function EditIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="var(--color-highlight)"
        fillRule="evenodd"
        d="M14.497 1.507a3.435 3.435 0 00-4.86 0L1.645 9.501a.624.624 0 00-.172.321L.512 14.76a.653.653 0 00.172.56.612.612 0 00.56.172l4.94-.961a.612.612 0 00.322-.172l7.99-7.992a3.437 3.437 0 000-4.859zm-8.74 11.831l-3.84.75.748-3.837 6.342-6.343L12.1 7l-6.342 6.338zm7.858-7.853l-.63.63-3.093-3.092.63-.63a2.136 2.136 0 013.093 0 2.191 2.191 0 010 3.092z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default EditIcon;
